var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navigation" }, [
    _c("ul", [
      _c(
        "li",
        [
          _c("router-link", { staticClass: "brand", attrs: { to: "/" } }, [
            _c("img", {
              attrs: { src: require("../../assets/logo.png"), width: "40px" },
            }),
            _c("strong", [_vm._v("DOGEBOOK")]),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("ul", [
      _vm.isProfileLoaded
        ? _c(
            "li",
            [
              _c("router-link", { attrs: { to: "/account" } }, [
                _vm._v(_vm._s(_vm.name)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("li", { on: { click: _vm.logout } }, [
            _c("span", { staticClass: "logout" }, [_vm._v("Logout")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAuthenticated && !_vm.authLoading
        ? _c(
            "li",
            [_c("router-link", { attrs: { to: "/login" } }, [_vm._v("Login")])],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }